import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import VueCookies from "vue-cookies";
import "./assets/iconfont/font/iconfont.css";
import vueEsign from "vue-esign";
import Print from "vue-print-nb";
import "./style.css";
import $ from "jquery";
import axios from "axios";

// this.$getUserIP(_this, (0全部，1登录，2新增，3编辑，4详情，5删除),$cookies.get("moduleId"),'内容')
import { getUserIP } from "@/api/userIp.js";
Vue.prototype.$getUserIP = getUserIP;
Vue.use(Print);
Vue.use(vueEsign);
Vue.use(VueCookies);
Vue.use(ElementUI);
Vue.prototype.$ = $;
Vue.config.productionTip = false;
Vue.prototype.$axios = axios;

let menus = [];
let isOrg = false;//是否在组织架构内

router.beforeEach(async (to, from, next) => {
  if (to.path === "/syIndex") {
    next();
    return;
  } else {
    checkLogin(to, from, next);
  }
});
function pcUrl() {
  let geturl = window.location.href;
  let getqyinfo = geturl.split("?")[1];
  let getqys = new URLSearchParams("?" + getqyinfo);
  let getqycode = getqys.get("SSOID");
  return getqycode;
}

function checkLogin(to, from, next) {
  let SSOID = pcUrl() || $cookies.get("SSOID");
  var url = "https://sso.chci.cn/ssoJsonLogin.do";
  if (SSOID) {
    console.log("有SSOID", SSOID);
    url = "https://sso.chci.cn/ssoJsonLogin.do?ticket=" + SSOID;
  }
  console.log(url);
  $.ajax({
    //备用请求 和下面的vue-jsop实际效果是一样的  只不过这个是jq
    url: url,
    type: "GET",
    async: false,
    dataType: "jsonp",
    jsonp: "mycallback",
    xhrFields: {
      withCredentials: true, //解决跨服务传递时不传递cookie的问题，允许携带证书
    },
    crossDomain: true, //允许跨域
    timeout: 5000,
    success: async function (data) {
      console.log("[ data ] >", data);
      // 不需要登录的界面
      // 没有登录
      if (data.error) {
        if (to.path === "/index") {
          next()
          return
        }
        store.state.onceRequest = false; //让登录接口掉用一次只
        store.commit("closeAllTab"); //账号失效清空上面的tab
        // 去登录界面
        let returnUrl = encodeURIComponent(window.location.href);
        window.location.href =
          "https://sso.chci.cn/login.do?method=get&returnURL=" + returnUrl;
        return;
      }
      await setDomainCookie(data);
      await getModuleListFunc();
      await getCompanyByUserFunc();
      judgePer(next, to, from);
      // next();
      // logingsLog();
      // ----- 调取接口  存store侧边栏  处理 地址路由
    },
  });
}
//没权限退出登录 在登录有权限的 防止sso跳回来
function judgePer(next, to, from) {
  console.log("from", from, from.path == "/admin", to);
  console.log(menus, "123123");
  //前往不是前台首页的路由，则做判断，
  if (to.path != '/index') {
    // 如果账号没有运营，则提示，返回到首页。
    if ($cookies.get("operateStatus") != "1") {
      Vue.prototype.$message({
        message: "您当前账号暂无访问权限，请联系管理员开通角色权限后再尝试！",
        type: "error",
      });
      next('/')
      return
    }
  }


  if (to.path == "/admin") {
    // 根据树 默认第一个高亮，如果没有子菜单，直接命中，有子菜单，跳过数字化营销。然后继续找下一个符合的url
    for (let item of menus) {
      if (item.url == "digital") continue;
      router.push('/' + getFirstUrl(item))
      // next({path:"/" });
      return;
    }
  }

  const isExist = findRouteUrl(menus, to.path.replace(/^\//, ""));
  console.log(isExist, "isExist");
  if (from.path == "/noPermission") {
    router.back();
    return;
  }
  if (!isExist || to.path == "/noPermission") {
    console.log('fpatg', to.meta.fpath)
    if (to.meta.isTwinLarge) {
      next();
      return
    }
    if (!to.meta.fpath) {
      if (isOrg) {
        Vue.prototype.$message({
          message: "您当前账号暂无访问权限，请联系管理员开通角色权限后再尝试！",
          type: "error",
        });
      }
      return;
    }
    if (to.meta.fpath) { next(); };
    const isExistFpath = findRouteUrl(menus, to.meta.fpath.replace(/^\//, ""));
    console.log(isExistFpath, "isExistFpath");
    if (isExistFpath) {
      const moduleId = findIdByUrl(menus, to.meta.fpath.replace(/^\//, ""));
      $cookies.set("moduleId", moduleId);
      next();
    } else {
      next({ path: "/noPermission" });
    }
  } else {
    const moduleId = findIdByUrl(menus, to.path.replace(/^\//, ""));
    $cookies.set("moduleId", moduleId);
    console.log(12121212121)
    next();
  }
  // return next();
}

function getFirstUrl(menuItem) {
  if (menuItem.subs && menuItem.subs.length > 0) {
    return menuItem.subs[0].url;
  } else {
    return menuItem.url;
  }
}

/**
 * 递归查找菜单树中指定 url 对应的 id
 * @param {Array} menuList 菜单树形数组
 * @param {String} targetUrl 要查找的 url
 * @returns {Number|null} 找到返回 id，找不到返回 null
 */
function findIdByUrl(menuList, targetUrl) {
  // 遍历每一级菜单
  for (const item of menuList) {
    // 如果当前项 url 匹配，直接返回 id
    if (item.url === targetUrl) {
      return item.id;
    }

    // 如果有子菜单，递归查找
    if (item.subs && item.subs.length > 0) {
      const result = findIdByUrl(item.subs, targetUrl);
      // 子级找到就直接返回
      if (result !== null) {
        return result;
      }
    }
  }

  // 所有层级都没找到
  return null;
}

/**
 * 递归查找菜单树中是否存在指定路由url
 * @param {Array} menuList 菜单树形数据
 * @param {String} targetUrl 要查找的路由地址
 * @returns {Boolean} 找到返回true，否则false
 */
function findRouteUrl(menuList, targetUrl) {
  // 遍历每一级菜单
  for (let item of menuList) {
    // 当前项url匹配 → 直接返回true
    if (item.url === targetUrl) {
      return true;
    }
    // 如果有子菜单，递归查找
    if (item.subs && item.subs.length > 0) {
      const result = findRouteUrl(item.subs, targetUrl);
      if (result) return true;
    }
  }
  // 全部遍历完没找到 → 返回false
  return false;
}

async function getModuleListFunc() {
  await $.ajax({
    method: "get",
    url:
      "/apis/hmcsDigitCommon/module/show/allList?SSOID=" +
      $cookies.get("SSOID") + "&systemType=1" + "&loginUserName=" + $cookies.get("username"),
    params: {
      loginUserName: $cookies.get("username"),
      systemType:1
    }
  }).then((res) => {
    if (res.code == 0) {
      console.log("Router tree", res.result.ownPermissionList);
      menus = res.result.ownPermissionList;
      isOrg = true;
    } else if (res.message == "登录信息超时") {
      window.localStorage.removeItem("userInfo");
      window.localStorage.removeItem("detectEntity");
      window.localStorage.removeItem("medicalEntity");
      $cookies.remove("isLogin");
      $cookies.remove("SSOID");
      $cookies.remove("nickname");
      $cookies.remove("headpic");
      $cookies.remove("userName");
      $cookies.remove("username");
      $cookies.remove("areaLayer");
      $cookies.remove("moduleId");
    } else {
      Vue.prototype.$message.error(res.message);
      isOrg = false;
    }
  });
}


async function getCompanyByUserFunc() {
  await $.ajax({
    method: "get",
    url:
      "/apis/hmcsDigitCommon/digitTenant/getTenant?SSOID=" +
      $cookies.get("SSOID"),
    params: {
      loginUserName: $cookies.get("username"),
    },
  }).then((res) => {
    if (res.code == 0) {
      if (res.result) {
        setCompanyInfo(res.result);
      }
    } else {
      // Vue.prototype.$message.error(res.message);
    }
  });
}
async function getByIdFunc() {
  await $.ajax({
    method: "get",
    url:
      "/apis/hmcsDigitCommon/digitTenant/getById?SSOID=" +
      $cookies.get("SSOID") + "&tenantId=64",
    params: {
    },
  }).then((res) => {
    if (res.code == 0) {
      if (res.result) {

        setCompanyInfo(res.result);
      }
    } else {
      Vue.prototype.$message.error(res.message);
    }
  });
}

function setCompanyInfo(data) {
  $cookies.set("tradeLayer", data.tradeLayer, "0"); ///行业编码
  $cookies.set("tradeName", data.tradeName, "0"); ///行业名称
  $cookies.set("operateStatus", data.operateStatus, "0"); ///运营状态（0：已关闭 1：已开通）
  console.log($cookies.get("operateStatus"), $cookies.get("tradeLayer"), $cookies.get("tradeName"))
}

function setDomainCookie(data) {
  store.state.userinfo = data;
  $cookies.set("SSOID", data.ticketVo.ticketEncryptKey, "0"); ///保存请求返回所有信息
  $cookies.set("username", data.ticketVo.username, "0"); ///保存请求返回所有信息
  $cookies.set("isLogin", true, "0"); ///保存请求返回所有信息
  $cookies.set("areaLayer", data.user.kqlayer, "0"); ///保存请求返回所有信息
  setDomainStoreState();
}

function setDomainStoreState() {
  store.state.isLogin = $cookies.get("isLogin");
  store.state.SSOID = $cookies.get("SSOID"); //所属管理地区
  store.state.username = $cookies.get("username"); //保存请求返回所有信息
}
function clearDomain() {
  $cookies.remove("isLogin");
  $cookies.remove("SSOID");
  $cookies.remove("username");
  $cookies.remove("areaLayer");

  store.state.isLogin = $cookies.get("isLogin"); //所属管理地区
  store.state.SSOID = $cookies.get("SSOID"); //保存请求返回所有信息
  store.state.username = $cookies.get("username"); //保存地区编码
  store.state.areaLayer = $cookies.get("areaLayer"); //保存地区编码
}

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
